import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "status"]
  static values  = { url: String }

  request(event) {
    event.preventDefault()

    const btn    = this.buttonTarget
    const token  = document.querySelector("meta[name='csrf-token']")?.content

    btn.disabled   = true
    btn.textContent = "Sending…"

    fetch(this.urlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token,
        "Accept": "application/json"
      }
    })
      .then(r => r.json())
      .then(data => {
        if (data.ok) {
          // Icon as markup, message as text — data.message is server-supplied.
          this.statusTarget.replaceChildren(
            Object.assign(document.createElement("i"), { className: "bi bi-check-circle me-1" }),
            document.createTextNode(data.message)
          )
          this.statusTarget.className   = "text-success small mt-2 d-block"
          btn.textContent = "Resend OTP"
        } else {
          this.statusTarget.textContent = "Error: " + (data.error || "Could not send OTP.")
          this.statusTarget.className   = "text-danger small mt-2 d-block"
          btn.textContent = "Request OTP"
        }
      })
      .catch(() => {
        this.statusTarget.textContent = "Network error. Please try again."
        this.statusTarget.className   = "text-danger small mt-2 d-block"
        btn.textContent = "Request OTP"
      })
      .finally(() => {
        btn.disabled = false
      })
  }
}
